import { render } from "./App.vue?vue&type=template&id=6d297a45"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6d297a45&lang=scss"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__